"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINToast = exports.PINToaster = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("@iconify/react");
var PINToaster = /** @class */ (function (_super) {
    __extends(PINToaster, _super);
    function PINToaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toasts: []
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'currents' implicitly has an 'any' type.
        _this.updateStateWithToasts = function (currents, nexts) {
            var nextToasts = nexts || [];
            /* Determine all the removed toasts */
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'toast' implicitly has an 'any' type.
            var outToasts = (currents || []).filter(function (toast) { return (nextToasts.indexOf(toast) < 0); });
            /* Add the status to toasts */
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'toast' implicitly has an 'any' type.
            nextToasts = nextToasts.map(function (toast) { return (__assign(__assign({}, toast), { status: "in" })); });
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'toast' implicitly has an 'any' type.
            outToasts = outToasts.map(function (toast) { return (__assign(__assign({}, toast), { status: "out" })); });
            /* Prepare the sorting function to maintain the order right */
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'a' implicitly has an 'any' type.
            var sortFunc = function (a, b) { return (a.creationTimestamp - b.creationTimestamp); };
            /* Save in the state */
            _this.setState(function () { return ({
                toasts: __spreadArrays(outToasts, nextToasts).sort(sortFunc)
            }); });
        };
        return _this;
    }
    PINToaster.prototype.componentDidMount = function () {
        this.updateStateWithToasts([], this.props.toasts);
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
    PINToaster.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateStateWithToasts(this.props.toasts, nextProps.toasts);
    };
    PINToaster.prototype.componentWillUnmount = function () {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };
    PINToaster.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "pintoaster" }, this.state.toasts.map(function (toast) { return (React.createElement(PINToast
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'creationTimestamp' does not exist on typ... Remove this comment to see the full error message
        , __assign({ 
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'creationTimestamp' does not exist on typ... Remove this comment to see the full error message
            key: "pintoaster" + toast.creationTimestamp, 
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'status' does not exist on type 'never'.
            className: "pintoast-" + toast.status, 
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'creationTimestamp' does not exist on typ... Remove this comment to see the full error message
            onClose: function () { _this.props.onToastClose(toast.creationTimestamp); } }, toast))); })));
    };
    PINToaster.propTypes = {
        toasts: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.oneOf(["success", "error", "info", "warning"]).isRequired,
            text: PropTypes.string.isRequired,
            subtext: PropTypes.string,
            creationTimestamp: PropTypes.number.isRequired
        })).isRequired,
        onToastClose: PropTypes.func.isRequired
    };
    return PINToaster;
}(React.Component));
exports.PINToaster = PINToaster;
var PINToast = function (props) {
    var iconMap = {
        success: "mdi:check-circle",
        error: "mdi:close",
        info: "mdi:information",
        warning: "mdi:alert",
    };
    return (React.createElement("div", { id: "pintoast-" + props.creationTimestamp, className: "pintoast pintoast-" + props.type + " " + props.className },
        React.createElement("div", { className: "pintoast-icon" },
            React.createElement(react_1.Icon, { color: "white", icon: iconMap[props.type], style: { fontSize: "3.4rem" } })),
        React.createElement("div", { className: "pintoast-content" },
            React.createElement("div", { className: "pintoast-content-text" }, props.text),
            React.createElement("div", { className: "pintoast-content-subtext" }, props.subtext)),
        React.createElement("button", { className: "pintoast-close", onClick: props.onClose },
            React.createElement(react_1.Icon, { color: "white", icon: "mdi:close", style: { fontSize: "2rem" } }))));
};
exports.PINToast = PINToast;
PINToast.propTypes = {
    type: PropTypes.oneOf(["success", "error", "info", "warning"]).isRequired,
    text: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    creationTimestamp: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};
//# sourceMappingURL=PINToaster.js.map